module.exports = __webpack_public_path__ + "static/media/ibd_neck2.d0e311c8.png";